module.exports = __webpack_public_path__ + "static/media/sutra_logo.5c19ad3e.png";